import {MouseEvent, useState} from 'react';

export const useNotificationsMenu = () => {
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLElement | null>(null);
  const [bulkActionsAnchor, setBulkActionsAnchor] = useState<HTMLElement | null>(null);
  const [notificationActionsAnchor, setNotificationActionsAnchor] = useState<HTMLElement | null>(null);
  const [selectedNotificationId, setSelectedNotificationId] = useState<string | null>(null);

  const openPopover = (event: MouseEvent<HTMLElement>) => {
    setPopoverAnchor(event.currentTarget);
  };

  const closePopover = () => {
    setPopoverAnchor(null);
    setBulkActionsAnchor(null);
    setNotificationActionsAnchor(null);
  };

  const openBulkActions = (event: MouseEvent<HTMLElement>) => {
    setBulkActionsAnchor(event.currentTarget);
  };

  const closeBulkActions = () => {
    setBulkActionsAnchor(null);
  };

  const openNotificationActions = (event: MouseEvent<HTMLElement>, id: string) => {
    setSelectedNotificationId(id);
    setNotificationActionsAnchor(event.currentTarget);
  };

  const closeNotificationActions = () => {
    setNotificationActionsAnchor(null);
  };

  const resetSelectedNotification = () => {
    setSelectedNotificationId(null);
  };

  return {
    popoverAnchor,
    isPopoverOpen: Boolean(popoverAnchor),
    bulkActionsAnchor,
    isBulkActionsOpen: Boolean(bulkActionsAnchor),
    notificationActionsAnchor,
    isNotificationActionsOpen: Boolean(notificationActionsAnchor),
    selectedNotificationId,
    openPopover,
    closePopover,
    openBulkActions,
    closeBulkActions,
    openNotificationActions,
    closeNotificationActions,
    resetSelectedNotification,
  };
};
